import clamp from 'text-overflow-clamp';


export default class ClampText extends React.PureComponent {

  static propTypes = {
    className: React.PropTypes.string,
    children: React.PropTypes.string,
    lineClamp: React.PropTypes.number,
    truncateText: React.PropTypes.string,
    textAlign: React.PropTypes.string,
  };

  static defaultProps = {
    lineClamp: 2,
    truncateText: '',
    textAlign: '',
  };

  componentDidMount() {
    this.clamp();
  }

  componentDidUpdate() {
    this.clamp();
  }

  clamp() {
    const clampOptions = _.omit(this.props, 'children');

    clamp(this._textNode, clampOptions);
  }

  render() {
    const { className, children } = this.props;

    return (
      <p ref={node => (this._textNode = node)}
         className={className}
         style={{ margin: 0, padding: 0 }}>
        {children}
      </p>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/clamp-text/clamp-text.js